<template>
  <div
    @mouseenter="hoverstart"
    @mouseleave="hoverend"
    :class="{ 'hovered' : hovered, 'clicked' : clicked }"
  >
    <router-link
      @click.native="emitMegamenuClick"
      @mouseleave.native="clicked = false"
      :to="categoryLink(category)"
    >
      <span>{{ category.name }}</span>
      <sub-btn
        v-if="category.children_count > 0"
        :id="category.id"
        :name="category.name"
      />
    </router-link>
    <div
      v-if="category.children_count > 0"
      class="megamenu-container"
    >
      <div class="container">
        <main-nav-level-one
          v-if="initialized" v-show="hovered"
          :category="category"
        />
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@vue-storefront/core/compatibility/plugins/event-bus'

import SubBtn from 'theme/components/core/blocks/Custom/SubBtn'
import MainNavLevelOne from 'theme/components/core/blocks/Custom/MainNavLevelOne'
import { formatCategoryLink } from '@vue-storefront/core/modules/url/helpers'
import { ensureMenuCategoryChildren } from 'theme/helpers/menu'
import megamenuHoverMixin from 'theme/mixins/megamenuHover'

export default {
  mixins: [megamenuHoverMixin('top')],
  props: {
    category: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      initialized: false,
      clicked: false
    }
  },
  components: {
    MainNavLevelOne,
    SubBtn
  },
  methods: {
    emitMegamenuClick () {
      EventBus.$emit('megamenu-clicked')
      this.clicked = true
    },
    async beforeMegamenuHover () {
      if (!this.initialized) {
        await ensureMenuCategoryChildren(this.$store, this.category.id, { withImage: true })
        this.initialized = true
      }
    },
    categoryLink (category) {
      return formatCategoryLink(category)
    }
  }
}
</script>
